module.exports = __webpack_public_path__ + "c6b5e3aa428dab93eabaf552642b2c61.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-ranger.png
// module id = 2279
// module chunks = 0